import { takeLatest, put, select } from "redux-saga/effects";
import {
  getArquivoEmCache,
  adicionarMedidasComDescricao,
  excluirMedidaSelecionada,
  getMedidaSelecionadaFIE,
  isPgblVgblSelecionado,
  getIndiceMedidaFIESelecionada,
  getModoApp,
} from "../state";
import {
  type MedidaSelecionada,
  type ModoApp,
  POSICAO_MEDIDA_FIE_AUTOMATICA,
  MODO_APP_SERIES,
} from "../model";

export default function* medidaFIESaga() {
  yield takeLatest(["SELECIONAR_ATIVOS"], function*(): any {
    const modoApp: ModoApp = yield select(getModoApp);
    if (modoApp === MODO_APP_SERIES) return;

    const arquivoEmCache: ?ArquivoMedida = yield select(getArquivoEmCache);
    if (arquivoEmCache) return;

    const isPGBL_VGBLSelecionado: boolean = yield select(isPgblVgblSelecionado);
    const indiceMedidaFIESelecionada: number = yield select(
      getIndiceMedidaFIESelecionada
    );
    const medidaSelecionadaFIE: MedidaSelecionada = yield select(
      getMedidaSelecionadaFIE
    );

    if (isPGBL_VGBLSelecionado) {
      if (indiceMedidaFIESelecionada === -1) {
        yield put(
          adicionarMedidasComDescricao(
            [medidaSelecionadaFIE],
            POSICAO_MEDIDA_FIE_AUTOMATICA
          )
        );
      }
    } else {
      if (indiceMedidaFIESelecionada === POSICAO_MEDIDA_FIE_AUTOMATICA) {
        yield put(excluirMedidaSelecionada(indiceMedidaFIESelecionada));
      }
    }
  });
}
